import type { ReactNode } from 'react'
import { contentSpecimens, IconLibrary } from './content'
import { feedbackSpecimens } from './feedback'
import { formsSpecimens } from './forms'
import { navigationSpecimens } from './navigation'

/** Live examples for the components added after the first library, by id. */
export const moreSpecimens: Record<string, (props: { mini?: boolean }) => ReactNode> = {
  ...formsSpecimens,
  ...navigationSpecimens,
  ...feedbackSpecimens,
  ...contentSpecimens,
}

/** A reference section some components add below their live example. */
export const componentReferences: Record<string, { title: string; intro: string; Body: () => ReactNode }> = {
  icon: {
    title: 'Icon library',
    intro: 'Every icon in the set, by the name the Icon component takes.',
    Body: IconLibrary,
  },
}
